export default __webpack_public_path__ + "static/media/h4.9a34079e.jpg";